// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"PerfOrderDetailsSkeletonDataGrid_skeletonContainer__cSVPU","skeletonRow":"PerfOrderDetailsSkeletonDataGrid_skeletonRow__iySQV"};